export const environment = {
  production: true,
  buildId: '3760030733723301',
  configFile: 'config.json',
};
